import { ButtonHTMLAttributes, MouseEvent, ReactNode } from 'react';
import { LinkProps } from 'react-router-dom';

export const IS_BUTTON_SYMBOL = Symbol('Button');

export type ButtonColor =
  | 'default'
  | 'text'
  | 'text-destructive'
  | 'call-to-action'
  | 'destructive';

export type ButtonShape =
  | 'pill' //  also circle
  | 'rounded'
  | 'sharp';

export type ButtonType = JSX.IntrinsicElements['button']['type'] | 'tab';

export interface MouseEventProps {
  originalEvent: MouseEvent<Element>;
}

export type ButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement> & LinkProps,
  | 'type'
  | 'shape'
  | 'to'
  | 'ref'
  | 'onClick'
  | 'onDoubleClick'
  | 'onFocus'
  | 'onMouseEnter'
  | 'onMouseLeave'
> & {
  autoFocus?: boolean;
  color?: ButtonColor;
  type?: JSX.IntrinsicElements['button']['type'] | 'link' | 'tab';
  rounding?: ButtonShape;

  isActive?: boolean;
  allowInteractionWhenDisabled?: boolean;
  inputId?: string;
  linkTo?: string;
  children?: ReactNode;

  insetFocus?: boolean;

  touchingTop?: boolean;
  touchingBottom?: boolean;
  touchingLeft?: boolean;
  touchingRight?: boolean;

  onClick?: (event: MouseEventProps) => void;
  onDoubleClick?: (event: MouseEventProps) => void;
  onFocus?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
} & React.AriaAttributes;
